module.exports = __webpack_public_path__ + "static/media/TIGIE-2017.b943c532.pdf";